import { useAppSelector } from "@/data/hooks";
import type { CountdownMessage } from "@/features/timeline/use-countdown/countdown-message";
import { useCountdown } from "@/features/timeline/use-countdown/use-countdown";

import {
  selectPreparationEndDate,
  selectPreparationEndDatePassed,
} from "../socratic-slice";

const EPOCH = "1970-01-01T00:00:00.000Z";

export function usePreparationCountdown(): CountdownMessage | null {
  const preparationEndDate = useAppSelector(selectPreparationEndDate);
  const preparationEndDatePassed = useAppSelector(
    selectPreparationEndDatePassed
  );

  const result = useCountdown(preparationEndDate ?? EPOCH);

  if (preparationEndDate === null || preparationEndDatePassed === true) {
    return null;
  }

  return result.passed ? null : result;
}
